import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import { fetchAccountInfo } from 'actions/account/account';
import css from 'styles/components/account/accountHeader.scss';

export class AccountHeader extends Component {

  componentDidMount() {
    const {
      account: { customerInfo },
      showCustomerEmail,
      fetchAccountInfo,
      routing: { locationBeforeTransitions: { pathname } }
    } = this.props;
    if (showCustomerEmail && !customerInfo) {
      fetchAccountInfo(pathname);
    }
  }

  makeLogoutLink = showLogoutLink => showLogoutLink && <>{' '}<Link to="/logout" className={css.logout} data-test-id={this.context.testId('logoutLink')}>Logout</Link></>;

  render() {
    const { title, account: { customerInfo }, showCustomerEmail, showFirstName, firstName, prime } = this.props;
    const customerEmail = customerInfo ? customerInfo.email : null;
    const { testId, marketplace: { account: { showLogoutLink } } } = this.context;

    return (
      <div className={css.accountHeader}>
        <h1 data-test-id={testId('heading')}>{title}{ prime && (<span className={css.primeBadge} aria-label="Amazon Prime badge" />) }</h1>
        {
          showCustomerEmail
            && customerEmail
            && (
              <div data-test-id={testId('accountGreeting')}>
                You are logged in as {customerEmail}
                {this.makeLogoutLink(showLogoutLink)}
              </div>
            )
        }
        {
          !showCustomerEmail
            && showFirstName
            && <div data-test-id={testId('accountGreeting')}>You are logged in as {firstName}</div>
        }
      </div>
    );
  }
}

AccountHeader.contextTypes = {
  testId: PropTypes.func,
  marketplace: PropTypes.object
};

AccountHeader.propTypes = {
  title: PropTypes.string.isRequired,
  showCustomerEmail: PropTypes.bool,
  showFirstName: PropTypes.bool
};

AccountHeader.defaultProps = {
  showCustomerEmail: true,
  showFirstName: false
};

export function mapStateToProps({ account, routing, holmes }) {
  const firstName = holmes ? holmes.firstName : '' || '';
  return {
    account,
    routing,
    firstName
  };
}

export default connect(mapStateToProps, {
  fetchAccountInfo
})(AccountHeader);
